import { render, staticRenderFns } from "./Conferencistas.vue?vue&type=template&id=8f07e0c4&"
import script from "./Conferencistas.vue?vue&type=script&lang=js&"
export * from "./Conferencistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports